module.exports = __webpack_public_path__ + "static/media/sydney-dip-smile-center.14797598.jpg";